import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export default function useMeasurement() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/measurement/create`, parameters).then(parseSuccessResponseData),
        });
    }

    function useListByProjectId() {
        return useMutation({
            mutationFn: (params: any) =>
                axiosPrivate.get(`/v1/measurement/list`, { params }).then(parseSuccessResponseData),
        });
    }

    function useUpdateSingleMeasurement() {
        return useMutation({
            mutationFn: (params: any) =>
                axiosPrivate.put(`/v1/measurement/update`, params).then(parseSuccessResponseData),
        });
    }

    return { useCreate, useListByProjectId, useUpdateSingleMeasurement };
}
